import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";
import { nullRenderer } from "../tableColumns";
import K from "../../../../utilities/constants";
import { convertIntoDashUSFormat } from "../../../../utilities/dateUtility";
import {
  displayDollar,
  displayPercentage,
} from "../../../../utilities/tableUtility";

const discountSourceTooltip = (data) => {
  const source = data?.discountSource;

  if (!source) {
    return null;
  }

  if (source.onThisInvoice) {
    return "Discount calculated based on current month hires.";
  }

  return `Discount calculated based on invoice ${source.invoiceId}.`;
};

export const DiscountedColumnDefs = [
  DefaultColumnOptions.Id,
  {
    headerName: "Candidate Name",
    field: "candidateName",
    sortable: true,
  },
  {
    headerName: "Candidate Type",
    field: "hireType",
    sortable: true,
    cellRenderer: (params) =>
      K.CandidateType[params.value] || nullRenderer.cellRenderer(params),
  },

  {
    headerName: "Billing Type",
    field: "billingTypeName",
    sortable: true,
    cellRenderer: (params) => params.data.billingTypeName ?? K.NullPlaceholder,
  },
  {
    headerName: "Start Date",
    field: "startDate",
    sortable: true,
    cellRenderer: (params) =>
      convertIntoDashUSFormat(params.data.startDate, false),
  },

  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    cellRenderer: (params) => params.data.jobTitle ?? K.NullPlaceholder,
  },

  {
    headerName: "Previous Amount",
    field: "duplicateAmount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.data.duplicateAmount ?? 0),
  },

  {
    headerName: "New Amount",
    field: "discountedAmount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.data.discountedAmount ?? 0),
  },

  {
    headerName: "Discount Percentage",
    field: "discountPercentage",
    sortable: true,
    cellRenderer: (params) =>
      displayPercentage(params.data.discountPercentage ?? 0),
    tooltipValueGetter: (params) => discountSourceTooltip(params.data),
  },
  {
    headerName: "Discount",
    field: "discount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.data.discount ?? 0),
  },
  {
    headerName: "Currency",
    field: "currency",
    sortable: true,
    cellRendere: (params) => params.data.currency,
  },
];

export const NonDiscountedColumnDefs = [
  {
    headerName: "ID",
    field: "id",
    sortable: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: "Candidate Name",
    field: "candidateName",
    sortable: true,
    cellRenderer: (params) => params.data.candidateName ?? K.NullPlaceholder,
  },
  {
    headerName: "Candidate Type",
    field: "hireType",
    sortable: true,
    cellRenderer: (params) =>
      K.CandidateType[params.value] || nullRenderer.cellRenderer(params),
    tooltipValueGetter: (params) => K.CandidateType[params.value],
  },
  {
    headerName: "Billing Type",
    field: "billingTypeName",
    sortable: true,
    cellRenderer: (params) => params.data.billingTypeName ?? K.NullPlaceholder,
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    cellRenderer: (params) => params.data.jobTitle ?? K.NullPlaceholder,
  },

  {
    headerName: "Amount",
    field: "duplicateAmount",
    sortable: true,
    cellRenderer: (params) => displayDollar(params.data.duplicateAmount ?? 0),
  },

  {
    headerName: "Currency",
    field: "currency",
    sortable: true,
    cellRendere: (params) => params.data.currency,
  },
];
